export function createConfirmationRequestCoordinator() {
  let activeRequest = null;
  let sequence = 0;

  function settle(request, value, detail) {
    if (!request || request.settled) return false;
    request.settled = true;
    if (activeRequest === request) activeRequest = null;
    // A confirmation resolves `true`, or — when the dialog carried a typed
    // confirmation — a frozen `{ approved: true, typedValue }` so the exact
    // text reaches the caller. Both are truthy; a cancellation is `false`.
    request.resolve(value === true
      ? (typeof detail?.typedValue === 'string' ? Object.freeze({ approved: true, typedValue: detail.typedValue }) : true)
      : false);
    return true;
  }

  return Object.freeze({
    replace(resolve) {
      if (typeof resolve !== 'function') {
        throw new TypeError('Confirmation request resolver must be a function');
      }
      if (activeRequest) settle(activeRequest, false);
      const request = {
        id: ++sequence,
        resolve,
        settled: false,
      };
      activeRequest = request;
      return request.id;
    },

    isActive(requestId) {
      return Boolean(activeRequest && activeRequest.id === requestId && !activeRequest.settled);
    },

    settle(requestId, value, detail) {
      if (!activeRequest || activeRequest.id !== requestId) return false;
      return settle(activeRequest, value, detail);
    },

    cancel() {
      return activeRequest ? settle(activeRequest, false) : false;
    },
  });
}

export function createConfirmationFocusCoordinator() {
  let captured = false;
  let target = null;

  return Object.freeze({
    capture(resolveTarget) {
      if (!captured) {
        target = typeof resolveTarget === 'function' ? resolveTarget() : null;
        captured = true;
      }
      return target;
    },

    clear() {
      captured = false;
      target = null;
    },
  });
}
